module.exports = __webpack_public_path__ + "41109f04025d3451b3a98b1b2f2dd199.svg";